(function(){
  'use strict';
  /* Phase158: registered with OTTRecordAudioManager so radio and beat previews use one audio authority. */
  function initGlobalPlayer(root){
    if(!root || root.dataset.ready === 'true') return;
    root.dataset.ready = 'true';

    var audio = root.querySelector('[data-ott-heartz-global-audio]');
    var play = root.querySelector('[data-ott-heartz-global-play]');
    var playText = root.querySelector('[data-ott-heartz-global-play-text]');
    var status = root.querySelector('[data-ott-heartz-global-status]');
    var minimize = root.querySelector('[data-ott-heartz-global-minimize]');
    var track = root.querySelector('[data-ott-heartz-global-track]');
    var artist = root.querySelector('[data-ott-heartz-global-artist]');
    var radioLive = root.getAttribute('data-radio-live') === 'true';
    var streamUrl = radioLive ? (root.getAttribute('data-stream-url') || '') : '';
    var apiUrl = root.getAttribute('data-api-url') || '';
    var playLabel = root.getAttribute('data-play-label') || 'Écouter';
    var pauseLabel = root.getAttribute('data-pause-label') || 'Pause';
    var loadingLabel = root.getAttribute('data-loading-label') || 'Connexion';
    var errorLabel = root.getAttribute('data-error-label') || 'Flux indisponible';
    var timer = null;
    var connectionWarmed = false;
    var storageKey = 'ottHeartzGlobalPlayerCollapsed';

    function setStatus(text){ if(status && text) status.textContent = text; }
    function warmRadioConnection(){
      if(!radioLive || connectionWarmed || !streamUrl) return;
      connectionWarmed = true;
      try{
        var streamOrigin = new URL(streamUrl, window.location.href).origin;
        if(streamOrigin && streamOrigin !== window.location.origin){
          var link = document.createElement('link');
          link.rel = 'preconnect';
          link.href = streamOrigin;
          link.crossOrigin = 'anonymous';
          document.head.appendChild(link);
        }
      }catch(error){}
    }
    function startMetadataUpdates(){
      if(!radioLive) return;
      refreshNowPlaying();
      if(apiUrl && !timer) timer = window.setInterval(refreshNowPlaying, 30000);
    }
    function stopMetadataUpdates(){
      if(timer){ window.clearInterval(timer); timer = null; }
    }
    function storageGet(key){ try { return window.localStorage && window.localStorage.getItem(key); } catch(error){ return null; } }
    function storageSet(key, value){ try { if(window.localStorage) window.localStorage.setItem(key, value); } catch(error){} }
    function setCollapsed(collapsed){
      root.classList.toggle('is-collapsed', !!collapsed);
      if(minimize){
        minimize.textContent = collapsed ? '+' : '−';
        minimize.setAttribute('aria-expanded', collapsed ? 'false' : 'true');
        minimize.setAttribute('aria-label', collapsed ? 'Agrandir le lecteur OTTHeartz' : 'Réduire le lecteur OTTHeartz');
      }
      storageSet(storageKey, collapsed ? 'true' : 'false');
    }
    function setButton(isPlaying){
      root.classList.toggle('is-playing', !!isPlaying);
      if(playText) playText.textContent = isPlaying ? pauseLabel : playLabel;
      if(play) play.setAttribute('aria-label', isPlaying ? 'Mettre OTTHeartz Radio en pause' : 'Écouter OTTHeartz Radio');
      setStatus(isPlaying ? 'En direct' : 'Prêt à écouter');
      document.dispatchEvent(new CustomEvent('ott:audio:radio-state', { detail: { playing: !!isPlaying, status: isPlaying ? 'En direct' : 'Prêt à écouter' } }));
    }
    function pauseOtherAudio(){
      if(window.OTTRecordAudioManager && typeof window.OTTRecordAudioManager.pausePreview === 'function'){
        window.OTTRecordAudioManager.pausePreview(true);
      }
      document.querySelectorAll('audio').forEach(function(item){
        if(item !== audio && !item.paused){
          try{ item.pause(); }catch(error){}
        }
      });
    }
    function pauseRadioForExternalAudio(event){
      var target = event && event.target;
      if(!audio || !target || target === audio) return;
      if(window.OTTRecordAudioManager && typeof window.OTTRecordAudioManager.isPreviewAudio === 'function' && window.OTTRecordAudioManager.isPreviewAudio(target)){
        if(!audio.paused){ try{ audio.pause(); }catch(error){} }
        return;
      }
      if(target.tagName && String(target.tagName).toLowerCase() === 'audio' && !audio.paused){
        try{ audio.pause(); }catch(error){}
      }
    }
    function updateNowPlaying(data){
      if(!data) return;
      var song = data.now_playing && data.now_playing.song ? data.now_playing.song : {};
      var live = data.live || {};
      var title = song.title || (live.is_live ? 'Live OTTHeartz' : 'Suggestion instrumentale disponible');
      var artistName = song.artist || live.streamer_name || 'Sélection OTTRecord · OTTCity';
      if(track) track.textContent = title;
      if(artist) artist.textContent = artistName;
      document.dispatchEvent(new CustomEvent('ott:audio:radio-meta', { detail: { title: title, artist: artistName } }));
    }
    function refreshNowPlaying(){
      if(!radioLive || !apiUrl || !window.fetch) return;
      fetch(apiUrl, { cache: 'no-store' })
        .then(function(response){ if(!response.ok) throw new Error('now playing unavailable'); return response.json(); })
        .then(updateNowPlaying)
        .catch(function(){ if(audio && !audio.paused){ setStatus('En direct'); } });
    }
    function playRadio(){
      if(!radioLive){
        setStatus('Radio en préparation · instrumentales disponibles');
        document.dispatchEvent(new CustomEvent('ott:audio:radio-unavailable', { detail: { reason: 'radio-disabled' } }));
        return;
      }
      if(!audio || !streamUrl){ setStatus(errorLabel); return; }
      warmRadioConnection();
      pauseOtherAudio();
      if(window.OTTRecordAudioManager && typeof window.OTTRecordAudioManager.setMode === 'function'){
        window.OTTRecordAudioManager.setMode('radio');
      }
      setStatus(loadingLabel);
      if(!audio.getAttribute('src')){
        audio.setAttribute('src', streamUrl);
        try{ audio.load(); }catch(error){}
      }
      var attempt = audio.play();
      if(attempt && typeof attempt.catch === 'function'){
        attempt.catch(function(){ setButton(false); setStatus(errorLabel); document.dispatchEvent(new CustomEvent('ott:audio:radio-unavailable', { detail: { reason: 'play-rejected' } })); });
      }
    }

    if(radioLive && window.OTTRecordAudioManager && typeof window.OTTRecordAudioManager.registerRadio === 'function'){
      window.OTTRecordAudioManager.registerRadio(audio);
    }
    document.addEventListener('ott:audio:pause-radio', function(event){
      if(audio && !audio.paused){ try{ audio.pause(); }catch(error){} }
    });

    if(minimize){
      minimize.addEventListener('click', function(){ setCollapsed(!root.classList.contains('is-collapsed')); });
      setCollapsed(storageGet(storageKey) === 'true');
    }
    document.addEventListener('click', function(event){
      var trigger = event.target && event.target.closest ? event.target.closest('[data-ott-play], audio, [data-audio], [data-preview]') : null;
      if(trigger && audio && !audio.paused && !root.contains(trigger)){ audio.pause(); }
    }, true);
    document.addEventListener('play', pauseRadioForExternalAudio, true);

    if(play && audio){
      if(!radioLive) setStatus('Radio en préparation · instrumentales disponibles');
      ['pointerenter','focus'].forEach(function(eventName){ play.addEventListener(eventName, warmRadioConnection, { once: true }); });
      play.addEventListener('click', function(){
        if(audio.paused){ playRadio(); }
        else{ audio.pause(); }
      });
    }
    if(audio){
      audio.addEventListener('playing', function(){
        setButton(true);
        root.classList.remove('has-error');
        if(window.OTTRecordAudioManager && typeof window.OTTRecordAudioManager.setMode === 'function') window.OTTRecordAudioManager.setMode('radio');
        document.dispatchEvent(new CustomEvent('ott:audio:radio-playing', { detail: { source: 'ottheartz' } }));
        startMetadataUpdates();
      });
      audio.addEventListener('pause', function(){ setButton(false); stopMetadataUpdates(); });
      audio.addEventListener('waiting', function(){ setStatus(loadingLabel); });
      audio.addEventListener('error', function(){ root.classList.add('has-error'); setButton(false); setStatus('Radio en préparation · instrumentales disponibles'); document.dispatchEvent(new CustomEvent('ott:audio:radio-unavailable', { detail: { reason: 'stream-error' } })); });
    }
    /* V501: no radio metadata request before the visitor starts playback. */
    document.addEventListener('shopify:section:unload', stopMetadataUpdates);
  }

  function boot(){
    document.querySelectorAll('[data-ott-heartz-global-player]').forEach(initGlobalPlayer);
  }
  if(document.readyState === 'loading') document.addEventListener('DOMContentLoaded', boot);
  else boot();
  document.addEventListener('shopify:section:load', boot);
})();
